import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import BarLoader from 'react-spinners/BarLoader'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(theme => ({
    wrapper: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    overlay: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 99,
        backgroundColor: "rgba(255,255,255,0.53)"
    }
}))

export default function Loading(props) {
    const classes = useStyles()
    const theme = useSelector(({ main }) => main.theme)

    const {
        width
    } = props

    return (
        <div className={props.overlay ? classes.overlay : classes.wrapper}>
            <BarLoader
                width={width || 300}
                height={4}
                color={theme.primary}
            />
        </div>
    )
}
